import { Box, Typography } from '@mui/material'
import CustomeDatePicker from 'components/ui/DatePicker/CustomeDatePicker'
import { TDateRange } from 'types/models/DataAnalysis'

interface DateFilterProps {
  dateRange: TDateRange
  onDateChange: (range: TDateRange) => void
}

export const DateFilter = ({ dateRange, onDateChange }: DateFilterProps) => (
  <Box>
    <Typography fontWeight={500}>Dates</Typography>
    <CustomeDatePicker
      startDate={dateRange.from}
      endDate={dateRange.to}
      handleDateChange={onDateChange}
    />
  </Box>
)
